import React, { useCallback } from 'react';

import ReportDateRange from '../ReportDateRange';

interface Props {
  testId?: string;
  prefix: string;
  disabled?: boolean;
  startDate: Date | null;
  endDate: Date | null;
  onSetStartDate: (value: Date | null) => void;
  onSetEndDate: (value: Date | null) => void;
}
const DateRangeSelector: React.FC<Props> = ({
  testId = 'date-range-selector',
  prefix,
  disabled,
  startDate,
  endDate,
  onSetEndDate,
  onSetStartDate,
}) => {
  const handleChangeValues = useCallback(
    (value: [Date | null, Date | null]) => {
      if (value[0] === null) {
        onSetStartDate(null);
        onSetEndDate(null);
      } else {
        onSetStartDate(value[0]);
        onSetEndDate(value[1]);
      }
    },
    [onSetEndDate, onSetStartDate]
  );
  return (
    <ReportDateRange
      values={[startDate, endDate]}
      testId={testId}
      disabled={disabled}
      onChangeValues={handleChangeValues}
      prefix={prefix}
    />
  );
};

export default DateRangeSelector;
